import BadgeNext from "ds/components/BadgeNext";
import { BadgeVariants } from "ds/components/BadgeNext/types";
import { BlueprintDeploymentState } from "types/generated";

type DeploymentStateConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const DEPLOYMENT_STATES: Record<BlueprintDeploymentState, DeploymentStateConfig> = {
  [BlueprintDeploymentState.Destroying]: { variant: "orange", text: "Deleting" },
  [BlueprintDeploymentState.DestroyingFailed]: { variant: "red", text: "Deleting Failed" },
  [BlueprintDeploymentState.Discarded]: { variant: "gray", text: "Discarded" },
  [BlueprintDeploymentState.Failure]: { variant: "red", text: "Failure" },
  [BlueprintDeploymentState.Finished]: { variant: "green", text: "Success" },
  [BlueprintDeploymentState.InProgress]: { variant: "blue", text: "In Progress" },
  // from UX perspective, "None" state is similar to "In Progress"
  [BlueprintDeploymentState.None]: { variant: "blue", text: "In Progress" },
  [BlueprintDeploymentState.Unconfirmed]: { variant: "yellow", text: "Unconfirmed" },
};

type DeploymentStateBadgeProps = {
  state: BlueprintDeploymentState;
};

const DeploymentStateBadge = ({ state }: DeploymentStateBadgeProps) => {
  if (!DEPLOYMENT_STATES[state]) {
    return null;
  }

  return (
    <BadgeNext
      variant={DEPLOYMENT_STATES[state].variant}
      type="strong"
      text={DEPLOYMENT_STATES[state].text}
    />
  );
};

export default DeploymentStateBadge;
